export type TCardProps = {
  children?: React.ReactNode
}

export const Card = ({ children }: TCardProps): JSX.Element => (
  <div className='shadow-flat rounded-2xl p-6'>{children}</div>
)
